import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SPONSOR_CAPACITY_DEFAULTS, ACTIVATION_DEFAULTS } from "@/data/content";

const FALLBACK = {
  tiers: Object.fromEntries(Object.entries(SPONSOR_CAPACITY_DEFAULTS).map(([k, v]) => [k, { capacity: v, remaining: v }])),
  activations: ACTIVATION_DEFAULTS.map((a) => ({ ...a, remaining: 1 })),
  partners: [],
  spotlights: {},
  loaded: false,
};

export function useSponsorConfig() {
  const [cfg, setCfg] = useState(FALLBACK);
  useEffect(() => {
    let alive = true;
    api.get("/sponsor-config").then((r) => alive && setCfg({ ...r.data, loaded: true })).catch(() => {});
    return () => { alive = false; };
  }, []);
  return cfg;
}

export const remainingFor = (cfg, key) => cfg?.tiers?.[key]?.remaining ?? null;

export const spotsLabel = (n) => {
  if (n === null || n === undefined) return "";
  if (n <= 0) return "Sold Out";
  return n === 1 ? "1 spot remaining" : `${n} spots remaining`;
};
